import { StateEntity } from '../entities/state-entity';

export default class State {
  current_codpais = '';

  items: Array<StateEntity> = [];
}
